// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1KHSL","fileBtn":"File_fileBtn__3w11t","closeBtn":"File_closeBtn__26lUu","fileSelected":"File_fileSelected__2byyA","disabled":"File_disabled__14afr"};